import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import config from '@/config';
const { API_URL } = config;

export const fetchUsers = createAsyncThunk('users/fetch', async (paginationParams) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/users?${new URLSearchParams(paginationParams).toString()}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const data = await response.json();
  return data;
});

export const fetchAllUsers = createAsyncThunk('users/fetchAll', async () => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/users?all=true`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const data = await response.json();
  return data;
});

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    items: [],
    counts: 0,
    status: 'idle',
    error: null,
    allUsers: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        if (action.payload.code === 200) {
          state.status = 'succeeded';
          state.items = action.payload?.data?.items ?? [];
          state.counts = action.payload?.data?.counts ?? 0;
          state.error = null;
        } else {
          state.status = 'failed';
          state.error = action.payload.message;
        }
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        if (action.payload.code === 200) {
          state.allUsers = action.payload?.data?.items ?? [];
        } else {
          state.allUsers = [];
          console.log('Помилка завантаження всих користувачів.', action.payload.message);
        }
      });
  },
});

export default usersSlice.reducer;
